
import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';

interface MenuSectionProps {
  title: string;
  links?: {
    name: string;
    href: string;
    description?: string;
    icon?: React.ReactNode;
  }[];
  onClose?: () => void;
  route?: string;
  children?: React.ReactNode;
}

const MenuSection = ({ title, links, onClose, route, children }: MenuSectionProps) => {
  return (
    <div className="py-2">
      <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-2 px-3">
        {title}
      </h3>
      
      {links && (
        <ul>
          {links.map((link, index) => (
            <li key={index}>
              <Link
                to={link.href}
                onClick={onClose}
                className={cn(
                  "flex items-center gap-2 px-3 py-2 hover:bg-synthreo-black-dark hover:text-synthreo-blue-medium text-white"
                )}
              >
                {link.icon && <span className="text-synthreo-blue-medium">{link.icon}</span>}
                <span>{link.name}</span>
                <ChevronRight size={16} className="ml-auto text-gray-500" />
              </Link>
            </li>
          ))}
        </ul>
      )}
      
      {children && (
        <div className="px-3">
          {children}
        </div>
      )}
    </div>
  );
};

export default MenuSection;
